const Autodesk = window.Autodesk;
import store from '@/store';
import { formatLength } from './../scripts/js/forgeService';
import { getViewPage360 } from '@/scripts/js/forgeviewer';
import { log as debugLog } from '@/utils/debugLogger';
import { drawMeasurement, MEASUREMENT_COLORS, CLOSE_ICON_HIT_PADDING } from '@/scripts/js/measurementRenderer';
const THREE = window.THREE;

const POINT_CLOUD_MAX_SNAP_DISTANCE = 10;

const MEASUREMENT_CURSOR = 'url("data:image/png;base64,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"), auto';

class MeasurementExtension extends Autodesk.Viewing.Extension {
    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;
        this.webGLDOM = this.viewer.container
            || this.viewer.canvas.closest('.adsk-viewing-viewer')
            || this.viewer.canvas.parentElement?.parentElement?.parentElement;

        this.isActive = false;
        this.isVisible = false;
        this.dragged = false;

        // Store bound references for proper add/remove
        this._onMouseUp = this.onMouseUp.bind(this);
        this._onMouseDown = this.onMouseDown.bind(this);
        this._onMouseMove = this.onMouseMove.bind(this);
        this._updateCanvas = this.updateCanvas.bind(this);
        this._resizeCanvas = this.resizeCanvas.bind(this);

        this.webGLDOM.addEventListener("click", this._onMouseUp);
        this.viewer.canvas.addEventListener("mousedown", this._onMouseDown);
        this.webGLDOM.addEventListener("mousemove", this._onMouseMove, false);

        // geometry
        this.startPoint = null;
        this.endPoint = null;
        this.dimensionLine = null;

        this.isMeasuring2D = !!loadedViewer?.impl?.is2d;
        this.differences = null;
        this.closeIconInfo = null;
        this._rafPending = false;
    }
    get sceneName() {
        return 'potree-scene';
    }
    get dimensionTextClass() {
        return this.isMeasuring2D ? 'floating-dimension-text-2d' : 'floating-dimension-text';
    }
    get canvasId() {
        return this.isMeasuring2D ? 'dimensionCanvas2d' : 'dimensionCanvas3d';
    }
    load() {
        debugLog('MeasurementExtension', `Extension loaded for ${this.isMeasuring2D ? '2D' : '3D'}`);

        this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this._updateCanvas);

        let element = document.getElementById('forgeViewer')

        if (!element) {
            element = document.getElementById('forgePlanViewer')
        }

        if (!element) return false;

        this._containerElement = element;

        const oldCanvas = document.getElementById(this.canvasId);

        if (oldCanvas) oldCanvas.remove();

        this.canvas = document.createElement('canvas');
        this.canvas.id = this.canvasId;
        this.canvas.style.position = 'absolute';
        this.canvas.style.top = '0';
        this.canvas.style.left = '0';
        this.canvas.style.pointerEvents = 'none';
        this.canvas.style.zIndex = '100';
        element.appendChild(this.canvas);
        this.canvas.width = element.offsetWidth;
        this.canvas.height = element.offsetHeight;
        this.ctx = this.canvas.getContext('2d');

        window.addEventListener('resize', this._resizeCanvas);
        document.addEventListener("keydown", this.onKeyDown);
        return true;
    }
    resizeCanvas() {
        const viewerDiv = this._containerElement;
        if (!viewerDiv || !this.canvas) return;
        this.canvas.width = viewerDiv.clientWidth;
        this.canvas.height = viewerDiv.clientHeight;
    }

    updateCanvas() {
        if (!this.ctx) return;
        this.drawDimensionLine(!this.endPoint);
    }
    drawDimensionLine() {
        if (!this.ctx) return;

        if (!this.isVisible || !this.dimensionLine) return;

        const v1 = this.dimensionLine.v1;
        const v2 = this.dimensionLine.v2;

        if (!v1 || !v2) return;
        // Clear the canvas
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            
        // Convert 3D points to 2D canvas coordinates
        const screenV1 = this.viewer.impl.worldToClient(v1);
        const screenV2 = this.viewer.impl.worldToClient(v2);

        this.differences = this.getDimensionsDifference();
        this.closeIconInfo = drawMeasurement(this.ctx, {
            p1: screenV1,
            p2: screenV2,
            distanceText: '~ ' + this.getDimensionText(),
            differences: this.differences,
            isMeasuring2D: this.isMeasuring2D,
            colors: MEASUREMENT_COLORS,
        });

    }        


    unload() {
        // Remove listeners added in load()
        document.removeEventListener("keydown", this.onKeyDown);
        this.viewer.removeEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this._updateCanvas);
        window.removeEventListener('resize', this._resizeCanvas);

        // Remove listeners added in constructor
        if (this.webGLDOM) {
            this.webGLDOM.removeEventListener("click", this._onMouseUp);
            this.webGLDOM.removeEventListener("mousemove", this._onMouseMove, false);
        }
        if (this.viewer?.canvas) {
            this.viewer.canvas.removeEventListener("mousedown", this._onMouseDown);
        }

        // Remove canvas from DOM
        if (this.canvas?.parentElement) {
            this.canvas.remove();
        }
        this.canvas = null;
        this.ctx = null;
        this._containerElement = null;

        return true;
    }
    onToolbarCreated() {
    }
    initSnapper() {
        if (!this.isMeasuring2D && Autodesk.Viewing.Extensions.Snapping) {
            if (!this.snapper) {
                this.snapper = new Autodesk.Viewing.Extensions.Snapping.Snapper(this.viewer);
            }
            this.snapper.activate();
        }
    }
    activate() {
        this.initSnapper();
        
        this.dimensionLine = null;
        this.startPoint = null;
        this.endPoint = null;
        this.isActive = true;
        this.isVisible = true;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        // Set measurement cursor
        this.viewer.canvas.style.cursor = MEASUREMENT_CURSOR;
    }
    setDimensionLine(start, end) {
        this.startPoint = start.clone();
        this.endPoint = end.clone();
        this.dimensionLine = new THREE.LineCurve(this.startPoint.clone(), this.endPoint.clone());
        this.isVisible = true;
    }
    deactivate(){
        if(this.snapper) this.snapper.deactivate();
        this.clear360Measurements();
        this.startPoint = null;
        this.endPoint = null;
        this.dimensionLine = null;
        this.differences = null;
        this.closeIconInfo = null;
        this.isVisible = false;
        this.isActive = false;
        if (this.ctx) {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        }

        // Restore cursor — isActive must be false before this call
        store.state.forgeService?.restoreViewerCursor(this.viewer);
    }
    stopMeasuring() {
        this.deactivate();
    }
    // Soft-complete: disarm the input tool WITHOUT clearing the rendered measurement.
    // Unlike deactivate(), this preserves dimensionLine / isVisible / closeIconInfo so the
    // line stays drawn, camera-tracking and closeable. Mirrors the native completion disarm
    // (onMouseUp). Used when the 360 path drives a measurement into this extension and must
    // leave it non-interactive (split-screen Bug 1).
    completeMeasurement() {
        this.isActive = false;                                   // must precede restoreViewerCursor
        if (this.snapper) this.snapper.deactivate();
        store.state.forgeService?.restoreViewerCursor(this.viewer);
    }
    onKeyDown = (event) => {
        if (event.key === 'Escape') {
            this.deactivate();
            store.commit("SET_IS_MEASURING", false);
        }
    }
    getSnappingPoint(mouse, checkPointCloud) {
        const pointOnModel = this.isMeasuring2D ? this.get2DPoint(mouse) : this.get3DPoint();
        const pointOnPointCloud = checkPointCloud && !this.isMeasuring2D ? this.getPointCloudPoint(mouse) : null;

        if (checkPointCloud && pointOnPointCloud) {
            const cameraPosition = this.viewer.navigation?.getPosition();
            if (cameraPosition && cameraPosition.distanceTo(pointOnPointCloud) <= POINT_CLOUD_MAX_SNAP_DISTANCE) {
                return { isOnModel: false, point: pointOnPointCloud };
            }
        }

        if (pointOnModel && !pointOnPointCloud) return { isOnModel: true, point: pointOnModel };
        if (!pointOnModel && pointOnPointCloud) return { isOnModel: false, point: pointOnPointCloud };
        if (pointOnModel && pointOnPointCloud) return this.getClosestPoint(pointOnModel, pointOnPointCloud);

        return null;
    }

    get2DPoint(mouse) {
        const mouseWorld = this.viewer.clientToWorld(mouse.offsetX, mouse.offsetY, true, true);
        return mouseWorld ? mouseWorld.point : null;
    }

    get3DPoint() {
        if (this.snapper) {
            const snapResult = this.snapper.getSnapResult();
            return snapResult.intersectPoint || snapResult.getVertex();
        }
        return null;
    }

    getPointCloudPoint(mouse) {
        try {
            return store.state.forgeService?.getMainExtension()?.pickNearestPointCloudPoint(mouse) ?? null;
        } catch (err) {
            debugLog('MeasurementExtension', 'Point cloud pick failed');
            return null;
        }
    }

    getClosestPoint(pointOnModel, pointOnPointCloud) {
        if (!pointOnModel || !pointOnPointCloud) return null;
        const cameraPosition = this.viewer.navigation.getPosition();
        return cameraPosition.distanceTo(pointOnModel) < cameraPosition.distanceTo(pointOnPointCloud)
            ? { isOnModel: true, point: pointOnModel }
            : { isOnModel: false, point: pointOnPointCloud };
    }
    drawPanoramaDimensionLine() {
        const forgeService = store.state.forgeService;

        if (!forgeService.panoramaViewer || !store.state.areViewsLocked) return;

        const page360Viewer = getViewPage360();
        
        if (!page360Viewer) return;

        page360Viewer.clearPanoDimension();
        
        page360Viewer.startPoint = this.dimensionLine.v1.clone();
        page360Viewer.endPoint = this.dimensionLine.v2.clone()
        page360Viewer.updatePanoDimensionLineInformation()
    }
    getDimensionsDifference() {
        const pt1 = this.dimensionLine.v1;
        const pt2 = this.dimensionLine.v2;

        if (this.isMeasuring2D) {
            if (!store.state.selectedLevel?.mappingViewersPointsInfo?.isReady()) {
                return { x: 'N/A', y: 'N/A' };
            }

            const pt1_3d = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(pt1);
            const pt2_3d = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(pt2);

            if (!pt1_3d || !pt2_3d) {
                return { x: 'N/A', y: 'N/A' };
            }

            return {
                x: formatLength(Math.abs(pt1_3d.x - pt2_3d.x), store.state.userSettings?.displaySettings?.displayUnits),
                y: formatLength(Math.abs(pt1_3d.y - pt2_3d.y), store.state.userSettings?.displaySettings?.displayUnits),
            }
        } else {
            const units = store.state.userSettings?.displaySettings?.displayUnits;
            return {
                x: formatLength(store.state.forgeService?.view3dToWorldLength(Math.abs(pt1.x - pt2.x)) ?? 0, units),
                y: formatLength(store.state.forgeService?.view3dToWorldLength(Math.abs(pt1.y - pt2.y)) ?? 0, units),
                z: formatLength(store.state.forgeService?.view3dToWorldLength(Math.abs(pt1.z - pt2.z)) ?? 0, units)
            }
        }
    }
    getDimensionText() {
        if (!this.dimensionLine) return '';

        const pt1 = this.dimensionLine.v1;
        const pt2 = this.dimensionLine.v2;

        let distance = 0;
        if (this.isMeasuring2D) {
            if (!store.state.selectedLevel?.mappingViewersPointsInfo?.isReady()) {
                return 'N/A';
            }
            const pt1_3d = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(pt1);
            const pt2_3d = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(pt2);
            if (!pt1_3d || !pt2_3d) return 'N/A';
            distance = pt1_3d.distanceTo(pt2_3d);
        } else {
            distance = store.state.forgeService?.view3dToWorldLength(pt1.distanceTo(pt2)) ?? 0;
        }
        return formatLength(distance, store.state.userSettings?.displaySettings?.displayUnits);
    }
    onMouseMove(mouse) {
        if (!this.isActive || !this.dragged) {
            this.dragged = true;
            return;
        }
        this._lastMouse = mouse;
        if (this._rafPending) return;
        this._rafPending = true;
        requestAnimationFrame(() => {
            this._rafPending = false;
            if (!this.isActive) return;

            const latestMouse = this._lastMouse;
            if (this.snapper) {
                this.snapper.handleMouseMove(latestMouse);
                this.snapper.indicator.render();
            }

            const point = this.getSnappingPoint(latestMouse, true);
            if (!point || !this.startPoint) return;

            this.dimensionLine = new THREE.LineCurve(this.startPoint.clone(), point.point);
            this.drawDimensionLine(true);
        });
    }
    onMouseDown(mouse) {
        if (mouse.button !== 0) return;
        this.dragged = false;
    }
    onMouseUp(mouse) {
        if (mouse.button !== 0) return;

        if (this.closeIconInfo) {
            const rect = this.canvas.getBoundingClientRect();
            const mouseX = mouse.clientX - rect.left;
            const mouseY = mouse.clientY - rect.top;

            const dx = mouseX - this.closeIconInfo.centerX;
            const dy = mouseY - this.closeIconInfo.centerY;
            const distance = Math.sqrt(dx * dx + dy * dy);

            if (distance <= this.closeIconInfo.radius + CLOSE_ICON_HIT_PADDING) {
                this.deactivate();
                return;
            }
        }

        if (!this.isActive || this.dragged) return;

        const point = this.getSnappingPoint(mouse, true);

        if (!point) return;

        this.viewer.clearSelection();

        if (this.startPoint && this.endPoint) {
            this.startPoint = null;
            this.endPoint = null;
        }

        if (this.startPoint) {
            this.endPoint = point.point.clone();
            this.dimensionLine = new THREE.LineCurve(this.startPoint.clone(), this.endPoint.clone());

            this.drawDimensionLine();
            this.drawPanoramaDimensionLine();

            store.commit("SET_IS_MEASURING", false);

            this.isActive = false;

            // Restore default Forge cursor — measurement complete
            store.state.forgeService?.restoreViewerCursor(this.viewer);

            if (this.snapper) {
                this.snapper.deactivate();
            }

        } else {
            this.startPoint = point.point.clone();
            this.clear360Measurements();
        }
    }

    clear360Measurements() {
        getViewPage360()?.clearPanoMeasuringDimensions();
        getViewPage360()?.clearPanoDimension();
    }
}
Autodesk.Viewing.theExtensionManager.registerExtension('MeasurementExtension', MeasurementExtension);
